const profile = {
  title: "Мой профайл",
  premiumBtn: "Зарегистрироваться",
  orderInfoTitle: "Информация о разрешении учетной записи",
  tableProduct: "Продукт",
  tableStatus: "Состояние",
  tablePermissionDate: "Дата разрешения",
  tableValidPeriod: "Срок действия",
  validStauts: "Действительный",
  expiredStauts: "Просроченный",
  noData: "Нет данных",
};

export default profile;
